import { render } from "./FluffyCat.vue?vue&type=template&id=56e466b4&scoped=true"
import script from "./FluffyCat.vue?vue&type=script&lang=js"
export * from "./FluffyCat.vue?vue&type=script&lang=js"

import "./FluffyCat.vue?vue&type=style&index=0&id=56e466b4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-56e466b4"

export default script